/**
 * Časově omezená oznámení zobrazovaná komponentou AppAnnouncements.
 *
 * Oznámení jsou záměrně jen v kódu (ne v DB) - jde o krátkodobé informace (např. odstávky
 * externích služeb), které po skončení platnosti stačí z tohoto seznamu smazat.
 *
 * Položka:
 * - id              unikátní identifikátor (slouží jako :key)
 * - requiresBankId  true = zobrazit jen u tenantů, kde je Bank iD dostupné (viz allowedBankID())
 * - showFrom/showTo okno platnosti; ISO s explicitní zónou, aby oznámení zmizelo ve stejnou
 *                   chvíli bez ohledu na časové pásmo zařízení klienta
 * - message         text podle jazyka aplikace (cs/sk); fallback je cs
 */
export const announcements = [
    {
        // IMA-519: plánovaná odstávka Bank iD 7. 10. 2026 20:00-24:00
        id: 'bankid-outage-2026-10-07',
        requiresBankId: true,
        showFrom: '2026-10-06T00:00:00+02:00',
        showTo: '2026-10-08T08:00:00+02:00',
        message: {
            cs: '<strong>Plánovaná odstávka Bank iD:</strong> Ve středu 7. 10. 2026 od 20:00 do 24:00 proběhne údržba služeb Bank iD. V této době nemusí fungovat přihlášení a ověření totožnosti přes Bank iD. Přihlášení e-mailem a heslem funguje bez omezení.',
            sk: '<strong>Plánovaná odstávka Bank iD:</strong> V stredu 7. 10. 2026 od 20:00 do 24:00 prebehne údržba služieb Bank iD. V tomto čase nemusí fungovať prihlásenie a overenie totožnosti cez Bank iD. Prihlásenie e-mailom a heslom funguje bez obmedzenia.',
        },
    },
];
